import { render, staticRenderFns } from "./region.vue?vue&type=template&id=18f0978a&scoped=true&"
import script from "./region.vue?vue&type=script&lang=js&"
export * from "./region.vue?vue&type=script&lang=js&"
import style0 from "./region.vue?vue&type=style&index=0&id=18f0978a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0978a",
  null
  
)

export default component.exports